import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';

import './index.scss';

export default function MobileFab({
  icon = 'add',
  label,
  onClick,
  disabled = false,
  variant = 'primary',
}: {
  icon?: IconType;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'send';
}) {
  return (
    <button
      type="button"
      className={`mobile-fab mobile-fab-${variant}`}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon iconType={icon} color="currentColor" size="small" />
      {label}
    </button>
  );
}
